import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db0e4e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-upcom__date" }
const _hoisted_2 = { class: "card-upcom__desc" }
const _hoisted_3 = { class: "card-upcom__location" }
const _hoisted_4 = { class: "card-upcom__time" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-upcom--divider" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "card-upcom__empty"
}
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = {
  key: 1,
  class: "card-upcom__empty card-upcom__empty--second"
}
const _hoisted_9 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_ProgressBarEmployee = _resolveComponent("ProgressBarEmployee")!
  const _component_ApplicantsPreview = _resolveComponent("ApplicantsPreview")!
  const _component_CardWrap = _resolveComponent("CardWrap")!
  const _component_router_link = _resolveComponent("router-link")!

  return (Object.keys(_ctx.item).length)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "upcoming-shift-link",
        to: { name: 'ShiftDetailsDescription', params: { id: _ctx.item.shiftId } }
      }, {
        default: _withCtx(() => [
          (Object.keys(_ctx.item).length)
            ? (_openBlock(), _createBlock(_component_CardWrap, {
                key: 0,
                class: "card-upcom--order card-upcom--padding-fix"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_1, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.shiftDate[0]), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.shiftDate[1]), 1)
                    ]),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.item.gigName), 1),
                    _createElementVNode("p", _hoisted_3, [
                      _createVNode(_component_FaIcon, {
                        class: "mq-p-icon",
                        icon: "location-dot"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.item.workLocation), 1)
                    ]),
                    _createElementVNode("p", _hoisted_4, [
                      _createVNode(_component_FaIcon, {
                        class: "mq-p-icon",
                        icon: "clock"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.startEndShift), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_ProgressBarEmployee, {
                      needed: _ctx.item.numberOfEmployeesNeeded,
                      accepted: _ctx.item.numberOfEmployeesAccepted,
                      class: "card-upcom__progress"
                    }, null, 8, ["needed", "accepted"]),
                    _hoisted_5,
                    _createVNode(_component_ApplicantsPreview, {
                      items: _ctx.imgUsers,
                      "num-of-applicants": _ctx.item.numberOfNewApplicants
                    }, null, 8, ["items", "num-of-applicants"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createBlock(_component_CardWrap, { key: 1 }, {
        default: _withCtx(() => [
          (_ctx.position === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FaIcon, {
                    class: "mq-p-icon mq-p-icon__calendar",
                    icon: "calendar-days"
                  })
                ]),
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("add_new_requests")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("no_shifts_planned")), 1),
                _createElementVNode("button", {
                  class: "shift-link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openRequestShiftDialog && _ctx.openRequestShiftDialog(...args)))
                }, " + " + _toDisplayString(_ctx.$t("global.add_new_request")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "shift-link",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openRequestShiftDialog && _ctx.openRequestShiftDialog(...args)))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_FaIcon, {
                      class: "mq-p-icon",
                      icon: "plus"
                    })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("global.add_new_request")), 1)
                ])
              ]))
        ]),
        _: 1
      }))
}